import React from "react";
import useCreateLocationApi from "../../Global/Api/Settings/createLocation";
import useUpdateLocationApi from "../../Global/Api/Settings/updateLocation";
import showToast from "../../Global/Hooks/toast";
import Button from "../../UI/Button";
import AutoSuggestInput from "../AutoSuggestInput";
import Popup from "../Popup";
import {
  isValidGoogleAddressLocation,
  parseGoogleAddressLocation,
  parseGoogleStreetAddress,
} from "../../Global/Hooks/parseGoogleAddress";

export default function LocationModal({
  setPopup,
  address,
  setAddress,
  currentAddress,
  setCurrentAddress,
}) {
  const createApi = useCreateLocationApi();
  const updateApi = useUpdateLocationApi();

  const closePopup = () => {
    setPopup(false);
    setAddress(null);
    setCurrentAddress(null);
  };

  const addressData = () => {
    const parsedLocation = parseGoogleAddressLocation(address?.info);
    let body = {
      full_address: currentAddress?.full_address || address?.address,
      address: currentAddress?.address || parseGoogleStreetAddress(address?.info),
      city: currentAddress?.city || parsedLocation?.city,
      state: currentAddress?.state || parsedLocation?.state,
      zip_code: currentAddress?.zip_code || parsedLocation?.zip,
      country: currentAddress?.country || parsedLocation?.country,
    };
    if (currentAddress) {
      body = { ...body, id: currentAddress?.id };
    }

    return body;
  };

  const validAddress = () => {
    const body = addressData();
    return !!(
      body.full_address &&
      isValidGoogleAddressLocation(body)
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const body = addressData();

    if (!validAddress()) {
      showToast("Invalid Address", "error");
    } else {
      if (!currentAddress) {
        createApi.send(body, closePopup);
      } else {
        updateApi.send(body, closePopup);
      }
    }
  };

  return (
    <Popup
      title={`${address ? "Edit" : "New"}  location`}
      closePopup={closePopup}
    >
      <div className="locations__popup-address">
        <label htmlFor="address">Your address</label>
        <AutoSuggestInput
          address={address?.full_address ? address?.full_address : address?.address}
          handleAddressChange={(e) => {
            setAddress(e);
            currentAddress && setCurrentAddress({ id: currentAddress?.id });
          }}
          placeholder="Enter address"
          className=""
        />
      </div>
      <p className="locations__popup-text">
        Please input your full address, the boxes below will complete
        automatically
      </p>
      <div className="locations__popup-inputs">
        <div className="locations__popup-input">
          <p className="locations__popup-inputPlaceholder">City</p>
          <p className="locations__popup-inputText">
            {address?.info
              ? address?.info
                  ?.filter((item) =>
                    item?.types?.includes("locality") ||
                    item?.types?.includes("administrative_area_level_2") ||
                    item?.types?.includes("sublocality") ||
                    item?.types?.includes("postal_town") ||
                    item?.types?.includes("neighborhood")
                  )
              .map((item, index) => (
                    <span key={index}>{item?.short_name}</span>
                  ))
              : address?.city}
          </p>
        </div>
        <div className="locations__popup-input">
          <p className="locations__popup-inputPlaceholder">State</p>
          <p className="locations__popup-inputText">
            {address?.info
              ? address?.info
                  ?.filter((item) => item?.types?.includes("administrative_area_level_1"))
                  .map((item, index) => (
                    <span key={index}>{item?.short_name}</span>
                  ))
              : address?.state}
          </p>
        </div>
      </div>
      <div className="locations__popup-inputs">
        <div className="locations__popup-input">
          <p className="locations__popup-inputPlaceholder">Country</p>
          <p className="locations__popup-inputText">
            {address?.info
              ? address?.info
                  ?.filter((item) => item?.types?.includes("country"))
                  .map((item, index) => (
                    <span key={index}>{item?.short_name}</span>
                  ))
              : address?.country}
          </p>
        </div>
        <div className="locations__popup-input">
          <p className="locations__popup-inputPlaceholder">ZIP</p>
          <p className="locations__popup-inputText">
            {address?.info
              ? address?.info
                  ?.filter((item) => item?.types?.includes("postal_code"))
                  .map((item, index) => (
                    <span key={index}>{item?.short_name}</span>
                  ))
              : address?.zip_code}
          </p>
        </div>
      </div>
      <div className="locations__popup-btn">
        <Button disabled={!address} text="Save" onClick={handleSubmit} />
      </div>
    </Popup>
  );
}
